var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 3.65625C4.20184 3.65625 3.65625 4.20184 3.65625 4.875C3.65625 5.54815 4.20184 6.09375 4.875 6.09375C5.54815 6.09375 6.09375 5.54815 6.09375 4.875C6.09375 4.20184 5.54815 3.65625 4.875 3.65625ZM4.875 6.90625C3.75334 6.90625 2.84375 5.99706 2.84375 4.875C2.84375 3.75294 3.75334 2.84375 4.875 2.84375C5.99665 2.84375 6.90625 3.75294 6.90625 4.875C6.90625 5.99706 5.99665 6.90625 4.875 6.90625ZM4.875 0C2.18278 0 0 2.18278 0 4.875C0 6.91356 4.06453 13.0045 4.875 13C5.67287 13.0045 9.75 6.88594 9.75 4.875C9.75 2.18278 7.56722 0 4.875 0Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/AddressIcon.cc697effa3eb9a3353e77ddd8ce733f3.svg";
export { ForwardRef as ReactComponent };